import { rem } from 'polished';
import styled from 'styled-components';

import { ArrowDown } from '../../icons';
import { IDiscoverMoreButtonProps } from './DiscoverMoreButton.types';

export const StyledTitle = styled.span`
  margin: ${rem('8px')} 0;
  font-size: ${rem('14px')};
  font-weight: 700;
  letter-spacing: ${rem('-.42px')};
  text-transform: uppercase;
`;

export const StyledButton = styled.button<IDiscoverMoreButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${rem('56px')};
  height: ${rem('56px')};
  margin: ${rem('8px')} 0;
  border: 1px solid ${({ theme }) => theme.colors.cross.silverFox};
  border-radius: 50%;
  background: transparent;
  padding: ${rem('21px')} ${rem('20px')} ${rem('19px')} ${rem('20px')};
  animation: updown 3s infinite;

  @keyframes updown {
    0% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
    100% {
      transform: translateY(0);
    }
  }
`;

export const StyledArrow = styled(ArrowDown)`
  height: ${rem('16px')};
  width: ${rem('16px')};
`;
